import { render, staticRenderFns } from "./ProductEfficiencyTests.vue?vue&type=template&id=77e061e1"
import script from "./ProductEfficiencyTests.vue?vue&type=script&lang=js"
export * from "./ProductEfficiencyTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports